import React from "react";
import { LabelColumn, Row, ValueColumn } from "src/components/shared/Sidebar/SidebarTable";
import { EMPTY_VALUE_DASH } from "src/constants";
import { localizeCurrencyToWholeNumber } from "src/utils";
import useSelector from "src/utils/useSelector";

interface Props {
    accessoriesTotal: number;
    showAccessories: boolean;
}

const Accessories = ({ accessoriesTotal, showAccessories }: Props) => {
    const upgradesLabel = useSelector((state) => state.account.account_disclaimers.upgrades_label);

    if (!showAccessories) {
        return null;
    }

    return (
        <Row>
            <LabelColumn>{upgradesLabel}</LabelColumn>
            <ValueColumn>
                {accessoriesTotal ? localizeCurrencyToWholeNumber(accessoriesTotal) : EMPTY_VALUE_DASH}
            </ValueColumn>
        </Row>
    );
};

export default Accessories;
